import MeetMessageCard from "./MeetMessageCard";
import ReactionBar from "./ReactionBar";
import { MessageView } from "@/interfaces/Chat";
export default function MessageRow({
  message,
  onJump,
  onReply,
  canWrite = false,
}: {
  message: MessageView;
  onJump: (id: string) => void;
  onReply?: (message: MessageView) => void;
  canWrite?: boolean;
}) {
  if (message.kind === "system")
    return (
      <article
        tabIndex={-1}
        data-message-id={message.id}
        className="chat-system"
      >
        {message.parts
          .map((p) => (p.type === "text" ? p.text : `@${p.label}`))
          .join("")}
      </article>
    );
  return (
    <article
      className="chat-message"
      data-message-id={message.id}
      tabIndex={-1}
      aria-label={`Message de ${message.author.name}`}
    >
      <span className="chat-avatar" aria-hidden="true">
        {message.author.avatarUrl ? (
          <img src={message.author.avatarUrl} alt="" />
        ) : (
          message.author.name
            .split(" ")
            .map((n) => n[0])
            .slice(0, 2)
            .join("")
        )}
      </span>
      <div className="chat-message-content">
        <div className="chat-message-meta">
          <strong>{message.author.name}</strong>
          <time
            dateTime={message.createdAt}
            title={new Date(message.createdAt).toLocaleString("fr-FR")}
          >
            {new Date(message.createdAt).toLocaleString("fr-FR", {
              weekday: "short",
              day: "numeric",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </time>
        </div>
        {message.reply && (
          <button
            className="chat-quote"
            onClick={() => onJump(message.reply!.id)}
          >
            <strong>{message.reply.authorName}</strong>
            <span>{message.reply.excerpt}</span>
          </button>
        )}
        <p>
          {message.parts.map((part, i) =>
            part.type === "text" ? (
              <span key={i}>
                {part.text
                  .split(/(https?:\/\/[^\s<>"']+)/g)
                  .map((text, index) =>
                    /^https?:\/\//.test(text) ? (
                      <a
                        key={index}
                        href={text}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {text}
                      </a>
                    ) : (
                      text
                    )
                  )}
              </span>
            ) : (
              <mark key={i}>@{part.label}</mark>
            )
          )}
        </p>
        {message.kind === "meet" && <MeetMessageCard message={message} />}
        <div className="chat-message-actions">
          {canWrite && onReply && (
            <button
              type="button"
              onClick={() => onReply(message)}
              aria-label={`Répondre à ${message.author.name}`}
            >
              Répondre
            </button>
          )}
          <ReactionBar message={message} canWrite={canWrite} />
        </div>
        {/* A bounded reading target also works when the message exceeds the viewport. */}
        <span
          className="chat-read-marker"
          data-chat-read-id={message.id}
          aria-hidden="true"
        />
      </div>
    </article>
  );
}
